module.exports = __webpack_public_path__ + "static/gifimg2-57be0a1071c16a828f2f9b1be6414e54.gif";